import { useContext } from 'react';
import { WindowDimensionsContext } from '../layout/context/WindowDimensionsContext';
export function useWindowDimensionsContext() {
  return useContext(WindowDimensionsContext);
}